import { render, staticRenderFns } from "./AppHeaderDropdown.vue?vue&type=template&id=1942d33d&scoped=true&"
import script from "./AppHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./AppHeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderDropdown.vue?vue&type=style&index=0&id=1942d33d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942d33d",
  null
  
)

export default component.exports